import React, { useEffect, useState } from 'react';
import { postData } from '../../lib/utils';

function AccountSetting({ appState }) {

  const [formData, setFormData] = useState({
    name: appState.adminDetails.name || '',
    email: appState.adminDetails.email || '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  console.log(appState.adminDetails,"form data ",formData)

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');


  useEffect(() => {
    if (appState?.adminDetails) {
      setFormData(prev => ({
        ...prev,
        name: appState.adminDetails.name || '',
        email: appState.adminDetails.email || ''
      }));
    }
  }, [appState.adminDetails]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  setError('');
  setSuccess('');

  // Step 1: Validate new passwords match FIRST
  if (formData.newPassword !== formData.confirmPassword) {
    setError('New passwords do not match.');
    return;
  }

  // Optional: agar new password empty ho to skip bhi kar sakte ho
  // if (!formData.newPassword) {
  //   setError('Please enter new password.');
  //   return;
  // }

  // Step 2: Validate current password
  const passwordCheckResponse = await postData('admin/validate-password', {
    
   
      email: formData.email,
      password: formData.currentPassword
  
  });

  const passwordCheck =   passwordCheckResponse;

  if (!passwordCheck.valid) {
    setError('Current password is incorrect.');
    return;
  }

  // Step 3: Send update request
  const updateResponse = await postData('admin/update-profile', {
  
      name: formData.name,
      email: formData.email,
      newPassword: formData.newPassword
  });

  if (updateResponse.success) {
    setSuccess('Profile updated successfully!');
  } else {
    setError('Update failed.');
  }
};

  return (
    <section className="border w-full text-left dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
          <form onSubmit={handleSubmit} className="mt-4 space-y-4 lg:mt-5 md:space-y-5">
            <div>
              <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your Name</label>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="John Doe"
                required
              />
            </div>

            <div>
              <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your Email</label>
              <input
                type="email"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="name@company.com"
                required
              />
            </div>

            <div>
              <label htmlFor="currentPassword" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Current Password</label>
              <input
                type="password"
                name="currentPassword"
                id="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                placeholder="••••••••"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>

            <div>
              <label htmlFor="newPassword" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">New Password</label>
              <input
                type="password"
                name="newPassword"
                id="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="••••••••"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="••••••••"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {error && <div className="text-red-600 text-sm">{error}</div>}
            {success && <div className="text-green-600 text-sm">{success}</div>}

            <button
              type="submit"
              className="w-full text-white bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5"
            >
              Update
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default AccountSetting;
